import * as React from 'react';
import { TableRowWrapper, ItemWrapper, FirstItemWrapper, FirstTextWrapper } from './TableRow_SC';
import { TextSizes, ToolTipWrapper, XIColors } from '@inmoment/the-kitchen';
import { RowItem } from '../Table';

export interface Props {
  rows: RowItem[];
  columnWidths: number[];
  extraEnabled?: boolean;
  useNameAsTextStyle?: boolean;
  isPropTable?: boolean;
}

export const TableRow: React.FC<Props> = (props) => {
  const { rows: items, columnWidths, extraEnabled, useNameAsTextStyle } = props;

  const mappedItems = items.map((item, i) => {
    const extra = extraEnabled ? columnWidths[i] * 0.026 : 0;
    if (i === 0) {
      return (
        <FirstItemWrapper width={columnWidths[i] + extra || 100} key={i} size="body">
          <FirstTextWrapper>
            <code>{item}</code>
          </FirstTextWrapper>
        </FirstItemWrapper>
      );
    } else {
      return (
        <ItemWrapper
          width={columnWidths[i] + extra || 100}
          key={i}
          size={i === 3 && useNameAsTextStyle ? (items[0] as TextSizes) : 'body'}
          style={{ paddingRight: i === items.length - 1 ? 0 : 6 }}
        >
          <TableItem>{item}</TableItem>
        </ItemWrapper>
      );
    }
  });
  return (
    <>
      <TableRowWrapper background={items[5] ? XIColors.green.light[30] : 'transparent'}>{mappedItems}</TableRowWrapper>
      <hr style={{ width: '100%' }} />
    </>
  );
};

const TableItem: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props;
  if (typeof children !== 'string' || children === '') {
    return <>{children}</>;
  }
  const maxLength = 75;
  const displayText = children.length < maxLength ? children : `${children.slice(0, maxLength - 3)}...`;
  return (
    <ToolTipWrapper text={children} enabled={children !== displayText}>
      <span style={{ overflowWrap: 'anywhere' }}>{displayText}</span>
    </ToolTipWrapper>
  );
};
